import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IBuilderComponentLoader, BuilderComponentRegistrar } from './types'
import { BuilderComponentLoaderSymbol } from './symbols'
import type { IComponentsLoader } from '@wix/thunderbolt-components-loader'
import { ComponentsLoaderSymbol } from '@wix/thunderbolt-components-loader'

export const builderComponentRegistrar = withDependencies(
	[ComponentsLoaderSymbol, BuilderComponentLoaderSymbol],
	(componentsLoader: IComponentsLoader, builderComponentsLoader: IBuilderComponentLoader): BuilderComponentRegistrar => {
		return {
			loadAndRegisterComponent: async ({ builderComponentId, componentUrl, builderType, appDefinitionId }) => {
				const loader = builderComponentsLoader.getComponentLoader(componentUrl, builderComponentId, appDefinitionId)

				await componentsLoader.registerComponent(builderType, loader)
			},
		}
	}
)
